import { memo } from 'react';

import styles from './TitleDescriptionList.module.css';
import { Col, Row } from 'antd';

interface TitleDescription {
  key: string;
  title: string;
  description: string;
}

interface TitleDescriptionListProps {
  datalist: TitleDescription[];
}

function TitleDescriptionList({ datalist }: TitleDescriptionListProps) {
  return (
    <ul className={styles.list}>
      {datalist.map(({ key, title, description }) => (
        <li key={key} className={styles.item}>
          <Row wrap={false}>
            <Col flex="0 0 80px">
              <span className={styles.title}>{title}</span>
            </Col>
            <Col>
              <span>{description}</span>
            </Col>
          </Row>
        </li>
      ))}
    </ul>
  );
}

export default memo(TitleDescriptionList);
